import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dialogcancelconfirm',
    templateUrl: './dialogcancelconfirm.component.html',
    styleUrls: ['./dialogcancelconfirm.component.css'],
    standalone: false
})
export class DialogcancelconfirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
